module.exports = __webpack_public_path__ + "img/primium-pay.de97d0a0.svg";